module.exports = __webpack_public_path__ + "media/images/workplace/pg_job_overlay-7e9e1d15b09ef28981c5277056ee3de9.png";